


const NotFound = ({ text }) => {
    return (
        <div className="flex flex-col items-center">
            <img src="/image/notFound.jpg" className="w-40" />
            <p className="text-center rtol mt-4 text-gray-500">
                {text}
            </p>
        </div>
    )
}
export default NotFound;